// extracted by mini-css-extract-plugin
module.exports = {"container":"_g","products":"ah","cta":"bh","disabled":"ch"};